// extracted by mini-css-extract-plugin
export default {"mainDiv":"Final_page_mainDiv__TLnlh"};